<template>
  <div class="game_item nS3vNq6zfAw_0i1GT8st" @click="playGame">
    <div
      class="goDRiiBsuEuXD3W1NphN xDdvC3cUGTm6TtkqLmyL ymBxiDlNFuhG407wKglz OO4vKnL46hg80HXLgmdt"
      :class="{
        mengBane: item.is_maintenance
      }"
    >
      <div class="fFW_uHsQoM95EC6sknGg"></div>
      <img
        class="is_maintenance"
        v-if="item.is_maintenance"
        src="./../../assets/icons/images/img_whz_style_1.webp"
        alt=""
      />
      <img
        class="gy98qRcKCBtFIJuUTF8N"
        v-if="item.favorable"
        src="./../../assets/icons/images/img_game_tj_1.webp"
        alt=""
      />
      <div class="" v-if="item.type == 'game'" @click.stop="favorite">
        <img
          class="rQ13hS2C2xOiatmUjuvy"
          v-if="item.is_favorite == 0"
          src="./../../assets/icons/images/btn_sc_off_2.webp"
          alt=""
        />
        <div class="rQ13hS2C2xOiatmUjuvy _fconte" v-if="item.is_favorite == 1">
          <img
            class="rQ13hS2C2xOiatmUjuvy_acction"
            src="./../../assets/icons/images/h-ac-star.png"
            alt=""
          />
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <svg-icon
          style="
            width: 100%;
            height: 100%;
            color: var(--theme-game-card-ddt_icon);
          "
          icon-class="img_mryx_card--svgSprite:all"
        />
      </div>
      <div loading="loading">
        <img class="conte_img" v-lazy="item.image" alt="" />
      </div>
    </div>
    <div class="game-name kXDK0ysXNcEV0AP33LlJ O8r1pxpgaW1Wd1QoPbLO">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
// favoriteGame
import { favoriteGame } from '@/apis/modules/home.js';
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'GameItem',
  props: {
    item: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'subgame'
    },
    category: {
      type: String,
      default: 'slot'
    }
  },
  data() {
    return {
      is_favorite: false,
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head'])
  },
  methods: {
    checkLogin() {
      if (!this.vuex_token_head) {
        if (this.rememberPassword && this.rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    favorite() {
      if (!this.checkLogin()) return false;
      favoriteGame({
        game_id: this.item.id,
        is_favorite: this.item.is_favorite == 0 ? 1 : 0
      }).then(({ code }) => {
        this.item.is_favorite = this.item.is_favorite == 0 ? 1 : 0;
      });
    },
    playGame(id) {
      if (this.item.is_maintenance) {
        Toast.fail({
          message: this.myLineBreaks(this.$t('_home._tis')),
          duration: 1000
        });

        // success
        // duration
        // Toast('O jogo está em manutenção');
        return false;
      }
      if (this.item.type != 'platform') {
        if (!this.checkLogin()) return false;
        if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 1
        ) {
          // 余额最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.balance_coin
          ) {
            Toast.fail({
              message:this.myLineBreaks(
                this.$t('_home._balanceLess1') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._balanceLess2')
              ),
              duration: 1500
            });
            return false;
          }
        } else if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 2
        ) {
          // 充值最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.recharge_total
          ) {
            Toast.fail({
              //message:this.$t('_home._rechargeLess1'),
              message:this.myLineBreaks(
                this.$t('_home._rechargeLess2') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._rechargeLess3')
              ),
              duration: 1500
            });
            return false;
          }
        }
      }
      // platform平台（点击跳游戏列表），
      // game游戏（点击后跳到玩游戏）
      if (this.item.type == 'platform') {
        // webview
        //
        if (this.type == 'home') {
          this.$router.push({
            name: 'subgame',
            query: {
              id: this.item.id,
              code: this.item.code,
              category: this.item.category || 'slot'
            }
          });
        }
        return false;
      } else {
        this.$router.push({
          name: 'webview',
          query: {
            id: this.item.id,
            category: this.item.category
            // =demo
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.nS3vNq6zfAw_0i1GT8st {
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: var(--name-img-layout-height);
  max-width: 100%;
  position: relative;
  margin: var(--cardRowSpacing) var(--cardColSpacing);
  width: var(--name-img-layout-width);
  z-index: 0;
}

.game_item {
  display: flex;
  --card-benchmark: 1.3rem !important;
  justify-content: center;
  box-sizing: border-box;
  --name-img-layout-width: calc(var(--card-benchmark) + 0.4rem);
  --name-img-layout-height: calc(var(--card-benchmark) * 1.288);
}
.kXDK0ysXNcEV0AP33LlJ {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -ms-flex-negative: 0;
  word-wrap: break-word;
  color: var(--theme-text-color);
  display: -webkit-box;
  flex-shrink: 0;
  font-size: var(--game-name-font-size);
  height: 2.76em;
  line-height: 1.38;
  margin-bottom: -1.38em;
  margin-top: var(--game-name-margin-top);
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: calc(var(--card-benchmark) + 0.4rem);
}

.O8r1pxpgaW1Wd1QoPbLO,
.U1WCkEy9uH9Nz3VqpPgT {
  --game-name-margin-top: calc(var(--card-benchmark) * 0.044);
  --game-name-font-size: calc(var(--card-benchmark) * 0.169);
}
.OO4vKnL46hg80HXLgmdt {
  --advertise-img-box-core-width: var(--card-benchmark);
  --advertise-img-box-core-height: var(--card-benchmark);
  --advertise-img-box-core-border-width: 0;
  --advertise-img-box-core-border-color: var(--theme-game-lobby-border);
  --advertise-img-box-core-border-radius: 0.2rem;
}
.ymBxiDlNFuhG407wKglz {
  -ms-flex-align: center;
  -ms-flex-pack: end;
  align-items: center;
  border-color: var(--advertise-img-box-core-border-color);
  border-style: solid;
  border-width: var(--advertise-img-box-core-border-width);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: var(--advertise-img-box-core-height);
  justify-content: flex-end;
  position: relative;
  width: var(--advertise-img-box-core-width);
}
.ymBxiDlNFuhG407wKglz {
  border-radius: var(--advertise-img-box-core-border-radius);
  overflow: hidden;
}

.mengBane .fFW_uHsQoM95EC6sknGg {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0;
  bottom: 0;
  cursor: not-allowed;
  left: 0;
  opacity: 1;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  -webkit-transition: opacity 0.6s;
  transition: opacity 0.6s;
  z-index: 9;
}

.game_title {
  border-radius: 0;
  text-align: center;
  width: 100%;
}
.game_img {
  --card-benchmark: 2.1rem;
  background-color: var(--theme-bg-color);
  align-items: center;
  border-color: var(--advertisement-box-border-color);
  border-style: solid;
  border-width: var(--advertisement-box-border-width);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  border-radius: var(--advertisement-box-border-radius);
  flex-direction: column;
  height: var(--advertisement-box-height);
  justify-content: flex-end;
  position: relative;
  width: var(--advertisement-box-width);
  overflow: hidden;
  margin: var(--cardColSpacing) var(--cardColSpacing) 0.3rem
    var(--cardColSpacing);
}
.conte_img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.is_maintenance {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
}
.gy98qRcKCBtFIJuUTF8N {
  --label-game-status-width: calc(var(--card-benchmark) * 0.333);
  --label-game-status-height: calc(var(--card-benchmark) * 0.25);
  height: var(--label-game-status-height);
  left: 0;
  position: absolute;
  z-index: 8;
  top: 0;
  width: var(--label-game-status-width);
}
.xDdvC3cUGTm6TtkqLmyL {
  --favorited-icon-side: calc(var(--card-benchmark) * 0.277);
  --favorited-icon-top: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-right: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-bottom: initial;
  --favorited-icon-left: initial;
  --click-arean-expand-size: -0.06rem;
}
.rQ13hS2C2xOiatmUjuvy {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  bottom: var(--favorited-icon-bottom);
  cursor: pointer;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: -ms-flexbox;
  display: flex;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  justify-content: center;
  left: var(--favorited-icon-left);
  line-height: 0;
  position: absolute;
  right: var(--favorited-icon-right);
  top: var(--favorited-icon-top);
  width: fit-content;
  z-index: 9;
  font-size: var(--favorited-icon-side);
  height: var(--favorited-icon-side);
  width: var(--favorited-icon-side);
}
._fconte {
  padding: 0.08rem;
  box-sizing: border-box;
}
._fconte .rQ13hS2C2xOiatmUjuvy_acction {
  width: 100%;
  height: auto;
  display: block;
}

.vyJOQO76ijmamNiW1_eF {
  /* line-height: 2.694; */
  webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  text-align: center;
  align-items: center;
  text-overflow: ellipsis;
  text-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.3);
  vertical-align: middle;
  -ms-flex-pack: center;
  word-wrap: break-word;
  color: var(--theme-text-color-task-btn);
  display: -ms-flexbox;
  display: flex;
  font-size: var(--game-platform-name-font-size);
  height: var(--game-platform-name-height);
  justify-content: center;
  margin-bottom: var(--game-platform-name-margin-bottom);
  padding: var(--game-platform-name-padding);
  width: 100%;
  position: relative;
  position: absolute;
  bottom: 0;
  z-index: 9;
}
</style>
